module.exports = __webpack_public_path__ + "img/zfsb.31d98f55.png";